import { useTranslation } from "react-i18next";
import Icon from "../components/Icon";
import Reveal from "../components/Reveal";
import SectionHead from "../components/SectionHead";
import { DIFFERENTIATORS } from "../data/trust";
import { useL } from "../lib/useLang";

export default function WhyUs() {
  const { t } = useTranslation();
  const L = useL();

  return (
    <section className="fsg-section fsg-why-us" id="por-que-elegirnos">
      <div className="fsg-container">
        <SectionHead
          title={t("why.title")}
          lead={t("why.lead")}
          center
        />

        <div className="fsg-why-us__layout">
          <Reveal as="figure" className="fsg-why-us__visual">
            <img
              src="/images/banner-2.jpeg"
              alt="Equipo de FSG celebrando certificaciones. Más que una agencia, construimos historias de éxito."
              width={1080}
              height={1080}
              loading="lazy"
            />
          </Reveal>

          <div className="fsg-grid fsg-grid--2 fsg-why-us__cards">
            {DIFFERENTIATORS.map((item, index) => (
              <Reveal
                key={item.icon}
                className="fsg-card fsg-card--hover"
                delay={index * 60}
              >
                <span className="fsg-card__icon">
                  <Icon name={item.icon} />
                </span>
                <h3>{L(item.title)}</h3>
                <p>{L(item.text)}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
